import { Label, Select } from "@xola/ui-kit";
import React, { useState } from "react";
import { RefundSelectOption } from "../../Dashboard/RefundOption";
import { CurrencyInput } from "../../Input/CurrencyInput";

interface RefundOptionsProps {
    initialAmount: number;
    amount: number;
    onChange: (amount: number, refundOption?: RefundSelectOption) => void;
}

export const RefundOptions = ({ initialAmount, amount, onChange }: RefundOptionsProps) => {
    const [option, setOption] = useState<RefundSelectOption>(RefundSelectOption.FULL);
    const handleOptionChange = (e: any) => {
        const { value } = e.target;
        setOption(value);

        switch (value) {
            case RefundSelectOption.NONE: {
                updateAmount(0, value);
                break;
            }

            case RefundSelectOption.FULL: {
                updateAmount(initialAmount, value);
                break;
            }

            case RefundSelectOption.PARTIAL: {
                updateAmount(amount, value);
                break;
            }
            // No default
        }
    };

    const handleChange = (amount: any) => {
        updateAmount(Number(-amount.value), option);
    };

    const updateAmount = (value: number, refundOption?: RefundSelectOption) => {
        onChange(value, refundOption);
    };

    return (
        <div>
            <Label>Refund</Label>
            <div className="flex space-x-2">
                <Select
                    value={option}
                    data-testid="purchase-change-quantity-modal-refund-select"
                    onChange={handleOptionChange}
                >
                    <option value="full">Full</option>
                    <option value="partial">Partial</option>
                    <option value="none">None</option>
                </Select>

                {option !== "none" && (
                    <CurrencyInput
                        data-testid="purchase-change-quantity-modal-refund-amount-field"
                        disabled={option === "full"}
                        placeholder="Amount"
                        value={Math.abs(amount) || null}
                        onValueChange={handleChange}
                    />
                )}
            </div>
        </div>
    );
};
